// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"270":"resumen","277":"estadisticas","692":"view","934":"plotly"}[chunkId] || chunkId) + "-legacy." + {"270":"cc615ca4","277":"0a461c66","323":"b53a6a6d","692":"1bd5c4c1","934":"452098f2"}[chunkId] + ".js";
};